import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTable, faTh } from "@fortawesome/free-solid-svg-icons";

type ViewMode = "table" | "card";

type InvoiceHeaderProps = {
  onCreateInvoice: () => void;
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
};

const InvoiceHeader: React.FC<InvoiceHeaderProps> = ({ 
  onCreateInvoice, 
  viewMode, 
  onViewModeChange 
}) => {
  return (
    <div className="invoice-page-header">
      <div>
        <h2>Invoicing</h2>
        <p className="header-sub">Track all financials here.</p>
      </div>
      <div className="invoice-header-actions">
        <div className="invoice-view-mode-toggle">
          <button
            className={`view-mode-btn ${viewMode === "table" ? "active" : ""}`}
            onClick={() => onViewModeChange("table")}
            title="Table View"
          >
            <FontAwesomeIcon icon={faTable} />
            <span>Table</span>
          </button>
          <button
            className={`view-mode-btn ${viewMode === "card" ? "active" : ""}`}
            onClick={() => onViewModeChange("card")}
            title="Card View"
          >
            <FontAwesomeIcon icon={faTh} />
            <span>Cards</span>
          </button>
        </div>
        <button onClick={onCreateInvoice} className="create-invoice-btn">
          <FontAwesomeIcon icon={faPlus} />
          <span>Create Invoice</span>
        </button>
      </div>
    </div>
  );
};

export default InvoiceHeader;
